const ProfessionalTeam = () => {
    return (
      <div>
      
      <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pr-[2rem] pt-[1rem]">
        <h1 className="text-[20px] font-bold">Professional Team</h1>
        <p>
          Our team of expert specialists carefully assesses every logistical need to help reduce 
          the cost without affecting customers’ plans or the project’s spirit. Being in business 
          for over forty years means that we work with intelligent logistics concepts that not only 
          increase our operational efficiency but also provide our customers with greater benefits.
        </p>
       
  
       
      </div>
    </div>  
    );
  };
    
  export default ProfessionalTeam;